import { Box, Flex, SegmentedControl, TextInput } from "@mantine/core"
import { MagnifyingGlassIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"

export type RouteQuickFilter =
  | "ALL"
  | "WAITING_DRIVER"
  | "PICKING"
  | "HANDOVER_READY"
  | "PRETRIP_PENDING"

interface Props {
  status: string
  onStatusChange: (next: string) => void
  statusOptions: { value: string; label: string }[]
  statusCounts?: Record<string, number>
  search: string
  onSearchChange: (value: string) => void
}

/** Status is a visible segmented switch (3 options), not a dropdown that hides them. */
export function RouteFiltersToolbar({
  status,
  onStatusChange,
  statusOptions,
  statusCounts,
  search,
  onSearchChange,
}: Props) {
  const { t } = useTranslation(["delivery"])

  const statusData = statusOptions.map((o) => ({
    value: o.value,
    label: statusCounts ? `${o.label} ${statusCounts[o.value] ?? 0}` : o.label,
  }))

  return (
    <Flex align="center" wrap="wrap" gap="md">
      <SegmentedControl
        value={status}
        onChange={onStatusChange}
        data={statusData}
        aria-label={t("delivery:route.filters.status")}
      />
      <Box w={{ base: "100%", xs: 280 }}>
        <TextInput
          aria-label={t("delivery:route.filters.search")}
          placeholder={t("delivery:route.filters.searchPlaceholder")}
          value={search}
          onChange={(e) => onSearchChange(e.currentTarget.value)}
          leftSection={<MagnifyingGlassIcon size={18} />}
        />
      </Box>
    </Flex>
  )
}
